import "./credit-selection.css";
import React, {useEffect, useState} from "react";
import {GetCreditList} from "../../api/getCreditList";
import useUserContext from "../../hooks/useUserContext";
import {PurchaseCredits} from "../../api/purchaseCredits";
import useAppContext from "../../hooks/useAppContext";
import useCredits from "../../hooks/useCredits";
import useGlobalModal from "../../hooks/useGlobalModal";
import {ToastSkin} from "../../context/ToastContext";
import useToast from "../../hooks/useToast";
import PaymentPanelNext from "../paymentPanel/PaymentPanelNext";
import {startCreditPackageChargingProcess} from "../../api/startCreditPackageChargingProcess";


interface CreditSelectionProps {
    isFullDisplay?: boolean;
    iconSize?: number;
    onSelect?: () => void;
    onSuccess?: () => void;
}

const CreditSelection = ({ isFullDisplay = true, iconSize = 100, onSelect, onSuccess }: CreditSelectionProps) => {
    const { selectedDomain } = useUserContext();
    const [creditList, setCreditList] = useState<{ id: number; credits: number; subtitle: string, cost: number }[] | null>(null);
    const { isFreePlan } = useCredits();
    const { data: { shop }, actions: { loadShop } } = useAppContext();
    const { showToast } = useToast();
    const [selectedCreditPlanId, setSelectedCreditPlanId] = useState<number | null>(null);
    const selectedCreditPlan = selectedCreditPlanId ? creditList?.find(creditItem => creditItem.id === selectedCreditPlanId) : null;
    const [isPaymentPanelOpen, setIsPaymentPanelOpen] = useState(false);
    const { availableCredits } = useCredits();

    const getCreditList = async () => {
        if(selectedDomain) {
            const response = await GetCreditList(selectedDomain);
            setCreditList(response.data);
        }
    }

    const onPurchaseCreditsClick = (creditPlanId: number) => async () => {
        if(selectedDomain) {
            if(shop.data?.platformId === 1) {
                const response = selectedDomain ? await PurchaseCredits(selectedDomain, creditPlanId) : null;
                if(response?.data?.url) {
                    window.open(response.data?.url);
                } else {
                    showToast({ skin: ToastSkin.error, text: "Failed to load Shopify's payment URL, Please try again or contact support" });
                }
            } else {
                setSelectedCreditPlanId(creditPlanId);
                setIsPaymentPanelOpen(true);
            }
        }
    }

    useEffect(() => {
        if(selectedDomain) {
            getCreditList();
        }
    }, [selectedDomain]);

    return (
        <div className="credit-selection-container">
            <div className="title">Buy Message Credits</div>
            <div className="sub-title">
                <div>One credit = One message. Credits expire in 12 months</div>
                {!isFreePlan ? null : <div>Credits are usable only on this/higher plans; downgrading disables them until you upgrade.</div>}
            </div>
            <div className="credit-deals-container">
                {creditList?.map(deal => <div className="credit-deal" onClick={onPurchaseCreditsClick(deal.id)}>
                    <div className="deal-header">
                        <div className="deal-header-bg"/>
                        <div className="credit-deal-count">{deal.credits.toLocaleString()}</div>
                        <div className="note messages">Messages</div>
                    </div>
                    <div className="deal-cost-container flex">
                        <div className="credit-deal-cost">${deal.cost}</div>
                    </div>
                    <div className="note subtitle">{deal.subtitle}</div>
                </div>)}
            </div>
            {/*<div className="credit-pricing-plans-banner" onClick={() => {*/}
            {/*    setIsCreditModalOpen(false);*/}
            {/*    setIsPricingPlanModalOpen(true);*/}
            {/*}}>*/}
            {/*    <div className="content-container">*/}
            {/*        <RocketUpIcon width={48} color='#d8c5ff' />*/}
            {/*        <div className="content">*/}
            {/*            <div className="title">Pay less per message</div>*/}
            {/*            <div className="subtitle">Upgrade your plan for better rates</div>*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*    <div className="actions">*/}
            {/*        <Button type="default" size="large">See plans</Button>*/}
            {/*    </div>*/}
            {/*</div>*/}
            <PaymentPanelNext
                isOpen={isPaymentPanelOpen}
                onClose={() => setIsPaymentPanelOpen(false)}
                title={`${selectedCreditPlan?.credits || 0} Credits Package`}
                entityId={selectedCreditPlan?.id}
                amountUsd={selectedCreditPlan?.cost || 0}
                paymentCall={startCreditPackageChargingProcess}
                afterSuccess={(successDetails: any) => {
                    console.log("successDetails: ", successDetails);
                    const invoiceNumberText = successDetails?.invoiceNumber ? ` Invoice No. ${successDetails?.invoiceNumber} has been issued.`: '';
                    const newTotalCredits = parseInt(availableCredits) + (parseInt(successDetails.entityId || 0));
                    const newCreditsText = successDetails?.entityId ? `${successDetails.entityId} credits added — you now have ${newTotalCredits} credits.` : 'Your balance has been updated successfully.';
                    showToast({ skin: ToastSkin.approval, text: `${newCreditsText}${invoiceNumberText}` });
                    loadShop();
                    onSuccess?.();
                }}
            />
        </div>
    );
}

export default CreditSelection;